<template>
    <div>
        <div class="mb-3">
            <placeholder size="lg" :width="18"/>
        </div>
        
        <div v-for="p in 2" :key="`agreement-placeholder-paragraph-${p}`" class="mb-3">
            <placeholder v-for="index in 24" :key="`agreement-placeholder-sentence-${p}-${index}`" :width="randomWidth()"/>
        </div>
    </div>
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';
    import Utilities from '@/classes/Utilities.js';

    export default {
        components: {
            ...CommonComponents,
        },
        
        methods: {
            randomWidth() {
                return Utilities.random(2, 12);
            },
        }
    };

</script>
